<template>
    <div class="videoTitle officer">
        <div style="text-align: left;">
            <el-date-picker v-model="day" type="date" placeholder="选择历史时间" style="width: 180px;" @change="changeDay">
            </el-date-picker>
        </div>
        <div style="text-align: right;font-size: 14px;">
            <el-time-select v-model="hours" :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '23:00'
            }" placeholder="选择时间" style="width: 180px;" @change="changeHours">
            </el-time-select>
        </div>
    </div>
</template>
<script>
import dayjs from 'dayjs'
export default {
    props: ['history_date'],
    data() {
        return {
            day: '',
            hours: '',
            start_date: '',
            end_date: ''
        }
    },
    created() {

    },
    mounted() {
        if (this.history_date) {
            this.day = dayjs(this.history_date[0]).format('YYYY-MM-DD');
            this.hours = dayjs(this.history_date[0]).format('HH:mm');
        }
    },
    methods: {
        changeDay() {
            this.hours = '00:00';
            this.format()
        },
        changeHours() {
            this.format()
        },
        format() {
            if (this.day && this.hours) {
              console.log(this.hours, 'this.hours')
                this.start_date = dayjs(this.day).format('YYYY-MM-DD') + ' ' + this.hours + ':00';
                this.end_date = dayjs(dayjs(this.start_date).add(20, 'minute')).format('YYYY-MM-DD HH:mm:ss');
                this.$emit('change', this.start_date, this.end_date)
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.videoTitle {
    display: flex;
    height: 40px;
    line-height: 40px;
    margin-top: 10px;
    font-weight: 600;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0;
    background-color: #fff;

    div {
        flex: 1;
    }
}

/deep/.el-input--prefix .el-input__inner {
    padding-left: 35px;
    color: #30BF30;
}
</style>



// WEBPACK FOOTER //
// src/views/cattlesubsidy/components/historyDate.vue